import { render, staticRenderFns } from "./Continue-Login.vue?vue&type=template&id=1f987940&scoped=true&"
import script from "./Continue-Login.vue?vue&type=script&lang=js&"
export * from "./Continue-Login.vue?vue&type=script&lang=js&"
import style0 from "./Continue-Login.vue?vue&type=style&index=0&id=1f987940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f987940",
  null
  
)

export default component.exports